// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Cd+KO","container":"styles_container__3CfV+","back-button":"styles_back-button__i1OgE"};